var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpfulToolRequestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.301 14.1726L14.0778 12.6884C14.7704 12.2926 15.9578 11.7978 16.0568 13.0842L16.4526 12.7873C17.7389 11.8968 18.7284 12.4905 18.3326 13.7768C20.6146 12.0947 21.4062 14.1726 20.4167 14.7663L15.2652 17.9389L13.0883 19.3241C11.4989 20.3136 9.51992 20.3136 8.92623 20.0168C5.65472 19.1262 4.76417 18.3347 1.89464 18.7305M0.509354 12.9852L3.87363 11.5999C4.76417 11.2041 5.65472 11.3031 6.0567 11.5999C6.65039 11.9957 7.24409 12.4905 7.83778 12.9852C10.4105 14.7663 10.6084 14.3705 13.583 14.4694C14.2757 14.5684 14.6715 15.6568 13.583 16.0526C10.8063 17.3452 9.12412 16.7515 6.55144 15.4589",
    stroke: "#1A1A1A",
    strokeWidth: 0.89178,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0922 3.96848C11.6964 3.77058 11.2017 3.67163 10.8059 3.57268C8.62899 3.37478 8.33214 5.55167 10.7069 5.55167C12.9889 5.55167 12.791 7.83368 10.509 7.53684C10.1132 7.53684 9.71743 7.33894 9.22268 7.23999M10.7069 2.18739L10.7069 3.27583L10.7069 2.18739ZM10.7069 7.73473L10.7069 8.72423L10.7069 7.73473ZM10.7069 1C13.1868 1 15.2648 3.07793 15.2648 5.55167C15.2648 8.13053 13.1868 10.2085 10.7069 10.2085C8.13424 10.2085 6.05631 8.13053 6.05631 5.55167C6.05631 3.07793 8.13424 1 10.7069 1Z",
    stroke: "#BA82BA",
    strokeWidth: 0.89178,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpfulToolRequestIcon);
export default __webpack_public_path__ + "static/media/helpful-tool-request-icon.78351aa9b51c4ee5402aab8785baaf94.svg";
export { ForwardRef as ReactComponent };